import { createApp } from 'vue'
import Kar from './Kar.vue'
import './assets/global.css'

createApp(Kar).mount('#kar')
